export default __webpack_public_path__ + "static/media/Upload.89a57a5d.svg";